import styled from 'styled-components';

export const Buttons = styled.div`
  left: 0;
  padding: 0 3rem;
  position: absolute;
  top: 50%;
  transform: translateY(-60%);
  z-index: 1;
`;
